(function() {
    'use strict';
 
a3_pilot_reports.factory('SettingsMain',SettingsMain);

    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name SettingsMain
    * @description 
    *    Generic add, edit or remove
    * @ngInject
    */
function SettingsMain(localStorageMD5Service){
        /**
        * Initialize the PageMainSettings
        * @memberof SettingsMain
        */
		function PageMainSettings() {
            this.EditingPage = null;
            this.selectedDate = null;
		}
				
        var service = {
                getSettings : getSettings,
                setSettings : setSettings,
                getEditingPage : getEditingPage,
                setEditingPage : setEditingPage,
                setCalendarViewStyle : setCalendarViewStyle,
                getCalendarViewStyle : getCalendarViewStyle,
                getCalendarSelectedDate : getCalendarSelectedDate,
                setCalendarSelectedDate : setCalendarSelectedDate
        }
        
         /**
         * Get Application Settings
         * @memberof SettingsMain
         * @returns {object} settings 
         */
		function getSettings(){
			var settings = new PageMainSettings();
			var settingsStored = localStorageMD5Service.get('settingsMain');
			if (settingsStored){
				if (settingsStored.EditingPage) 
					settings.EditingPage = settingsStored.EditingPage;		
                
                settings.calendarViewStyle = settingsStored.calendarViewStyle;
                settings.selectedDate = settingsStored.selectedDate;
			}
			return settings;
		}
    
	    /**
         * Set Application Settings
         * @param {object} settings
         * @memberof SettingsMain
         */
		function setSettings(settings){
			localStorageMD5Service.set('settingsMain',settings);
		}
        /**
         * Get editing page
         * @memberof SettingsMain
         * @returns {string} EditingPage
         */		
		function getEditingPage(){
			var settings = getSettings();
			return settings.EditingPage;
		}
        /**
         * Set editing page
         * @param {string} value
         * @memberof SettingsMain
         */
		function setEditingPage (value){
			var settings = getSettings();
			settings.EditingPage = value;
			setSettings(settings);
		}
    
     /**
         * Get prefered calendar view style
         * @memberof SettingsMain
         * @returns {string} viewStyle
         */
		function getCalendarViewStyle() {
			var settings = getSettings();
            var viewStyle = settings.calendarViewStyle;
            
            return viewStyle;
		}
    
        /**
         * Set prefered calendar view style
         * @param {string} value
         * @memberof SettingsMain
         */
		function setCalendarViewStyle(value) {
			var settings = getSettings();
			settings.calendarViewStyle = value;
			setSettings(settings);
		}
    
				
		/**
         * Get selected calendar date
         * @memberof SettingsMain
         * @returns {string} selectedDate
         */
        function getCalendarSelectedDate() {
            var settings = getSettings();
            var selectedDate = settings.selectedDate;
            
            return selectedDate;
        }
        /**
         * Set selected calendar date
         * @param {string} value
         * @memberof SettingsMain
         */
        function setCalendarSelectedDate(value) {
            var settings = getSettings();
            settings.selectedDate = value;
            setSettings(settings);
        }

	return service;
};
 
 })();   